import { connect } from 'react-redux';
import { updateLearnerHasEnrolmentConsentPermission } from './dispatchers';
import {
  selectCurrentLearnerHasEnrolmentConsentPermission,
  selectUpdateHasEnrolmentConsentPermissionError,
} from './selectors';
import { selectCurrentInstitution } from '../../../ReduxStorage/Institutions/selectors';
import { ReduxState } from '../../../ReduxStorage/state';
import { LearnersConsentModal } from './component';

export const ConnectedLearnersConsentModal = connect(
  (state: ReduxState) => ({
    currentInstitution: selectCurrentInstitution(state),
    learnerHasEnrolmentConsentPermission: selectCurrentLearnerHasEnrolmentConsentPermission(
      state
    ),
    updateLearnerHasEnrolmentConsentPermissionError: selectUpdateHasEnrolmentConsentPermissionError(
      state
    ),
  }),
  {
    updateLearnerHasEnrolmentConsentPermission,
  }
)(LearnersConsentModal);
